import moment from 'moment';
import { useRef, useState, useEffect } from 'react';

import { jwtDecode } from 'src/utils/isValidToken';

import { useAuth } from 'src/auth/auth.hook';
import { useAuthStore } from 'src/auth/auth.store';
import { useUserStore } from 'src/stores/user/user.store';
import { useMyLevelStore } from 'src/stores/user/my-level.store';
import { useMyInterestsStore } from 'src/stores/my-interests/my-interests.store';

import { useScrollToTop } from './use-scroll-to-top';

export const useApp = () => {
  useScrollToTop();
  const { initializeAuth } = useAuth();
  const { maybeLater } = useMyInterestsStore();
  const accesstoken = useAuthStore((state) => state.accessToken);

  const { setUseMyInterestsDialog, useMyInterestsDialog } = useMyInterestsStore((state) => state);

  // GAMBIARRA
  // const [setUseScanMissionDialog, setMissionModalViewed] = useHomeStore((state) => [
  //   state.setUseScanMissionDialog,
  //   state.setMissionModalViewed,
  // ]);

  const [openQuizDialog, setOpenQuizDialog] = useState(false);

  const [
    userPointsNotifications,
    isLoadingUserPointsNotifications,
    getUserPointsNotifications,
    user,
    myBalance,
  ] = useUserStore((state) => [
    state.userPointsNotifications,
    state.isLoadingUserPointsNotifications,
    state.getUserPointsNotifications,
    state.user,
    state.myBalance,
  ]);

  const [openConfettiDialog, setOpenConfettiDialog] = useState(false);
  const pollingTimerRef = useRef<number | null>(null);

  const getMyLevelInfo = useMyLevelStore((state) => state.getMyLevelInfo);

  useEffect(() => {
    initializeAuth();
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (accesstoken) {
        const userData = jwtDecode(accesstoken ?? '')?.data;

        try {
          // GAMBIARRA
          // if (!userData.missionModalViewedMothersDay) {
          //   setUseScanMissionDialog(true);
          //   setMissionModalViewed();
          //   return;
          // }

          if (
            !userData?.profileData?.main &&
            !userData?.profileData?.maybeLater &&
            moment().diff(moment(userData?.createdAt), 'days') >= 3
          ) {
            setUseMyInterestsDialog(true);
            return;
          }
          setUseMyInterestsDialog(false);

          if (userData?.profileData?.main) {
            setOpenQuizDialog(false);
            return;
          }

          if (userData?.profileData?.maybeLaterDate) {
            const maybeLaterDate = new Date(userData.profileData?.maybeLaterDate);
            const now = new Date();
            const daysDiff = Math.floor(
              (now.getTime() - maybeLaterDate.getTime()) / (1000 * 60 * 60 * 24)
            );

            if (daysDiff >= 7) {
              setOpenQuizDialog(true);
            } else {
              setOpenQuizDialog(false);
            }
          } else {
            setOpenQuizDialog(false);
          }
        } catch {
          setOpenQuizDialog(false);
        }
      }
    }, 1000);

    return () => clearTimeout(timeout);
  }, [accesstoken]);

  const handleCloseQuizDialog = async () => {
    try {
      await maybeLater();
      setOpenQuizDialog(false);
    } catch {
      console.error('error');
      setOpenQuizDialog(false);
    }
  };

  const handleRespondQuiz = () => {
    setOpenQuizDialog(false);

    setTimeout(() => {
      setUseMyInterestsDialog(true);
    }, 200);
  };

  const handleCloseConfetti = () => {
    setOpenConfettiDialog(false);
  };

  useEffect(() => {
    const isEligibleTier = user?.userLevel === 'silver' || user?.userLevel === 'gold';

    if (
      userPointsNotifications?.notify &&
      !isLoadingUserPointsNotifications &&
      userPointsNotifications?.notificationData?.type === 'pointsModal' &&
      isEligibleTier
    ) {
      setOpenConfettiDialog(true);
      getMyLevelInfo();
      myBalance();
    }

    if (userPointsNotifications?.notify) {
      getMyLevelInfo();
      myBalance();
    }
  }, [userPointsNotifications?.notify, isLoadingUserPointsNotifications, user?.userLevel]);

  useEffect(() => {
    if (pollingTimerRef.current) {
      clearTimeout(pollingTimerRef.current);
      pollingTimerRef.current = null;
    }

    if (openConfettiDialog) {
      return undefined;
    }

    if (!userPointsNotifications?.remainingTime || isLoadingUserPointsNotifications) {
      return undefined;
    }

    if (userPointsNotifications.stopRequests) {
      return undefined;
    }

    const timeoutMs = userPointsNotifications.remainingTime * 1000;

    pollingTimerRef.current = window.setTimeout(() => {
      getUserPointsNotifications().catch((error) => {
        console.error('Erro ao buscar notificações de pontos:', error);
      });
    }, timeoutMs);

    return () => {
      if (pollingTimerRef.current) {
        clearTimeout(pollingTimerRef.current);
        pollingTimerRef.current = null;
      }
    };
  }, [
    openConfettiDialog,
    userPointsNotifications?.remainingTime,
    getUserPointsNotifications,
    isLoadingUserPointsNotifications,
    user?.userLevel,
  ]);

  return {
    openQuizDialog,
    useMyInterestsDialog,
    openConfettiDialog,
    handleCloseConfetti,
    handleCloseQuizDialog,
    handleRespondQuiz,
  };
};
